/** Откуда пришли на страницу: для источника нового игрока и для Umami. */
import { Landing } from "@newfungame/contracts";

/** Хост внешнего referrer; свой сайт и пустой — `null`. */
export function externalReferrer(referrer: string, ownHost: string): string | null {
  try {
    const host = new URL(referrer).hostname.toLowerCase();
    return host && host !== ownHost ? host : null;
  } catch {
    return null;
  }
}

/**
 * UTM адреса и внешний referrer для источника игрока; метки вне формата отбрасываются. `webdriver` —
 * `navigator.webdriver`: страницу ведёт Playwright/Selenium, сервер пометит игрока проверкой (ISSUE-131).
 */
export function readLanding(search: string, referrer: string, ownHost: string, webdriver = false): Landing | null {
  const query = new URLSearchParams(search);
  const landing = Landing.parse({
    utmSource: query.get("utm_source") ?? undefined,
    utmCampaign: query.get("utm_campaign") ?? undefined,
    utmContent: query.get("utm_content") ?? undefined,
    referrer: externalReferrer(referrer, ownHost) ?? undefined,
    automated: webdriver || undefined,
  });
  return Object.values(landing).some(Boolean) ? landing : null;
}
